import * as React from 'react'

import { Controller } from 'react-hook-form'

import { IAttachment } from '~/client/graph'
import { useFilePreview } from '~/client/src/shared/contexts/FilePreviewContext'
import { openAttachmentPreview } from '~/client/src/shared/utils/filePreviewUtils'

import FilesInput from '../../FilesInput/FilesInput'
import { FileFieldConfig, FileUploadFn } from '../types'

interface FileFieldProps {
  field: FileFieldConfig
  control: any
  error?: string
  hideHelperText?: boolean
  uploadFn: FileUploadFn
}

export default function FileField({
  field,
  control,
  error,
  hideHelperText,
  uploadFn,
}: FileFieldProps) {
  const { showPreview } = useFilePreview()

  const onPreview = React.useCallback(
    (attachments: IAttachment[], index: number) => {
      openAttachmentPreview(attachments, index, showPreview)
    },
    [showPreview],
  )

  return (
    <Controller
      name={field.name}
      control={control}
      defaultValue={field.defaultValue || []}
      rules={{
        validate: val => {
          if (!field.required) return true
          const arr = Array.isArray(val) ? val : []
          if (arr.length === 0) {
            return `${field.label || field.name} is required`
          }
          return true
        },
      }}
      render={({ field: { onChange, value } }) => {
        const attachments: IAttachment[] = Array.isArray(value) ? value : []
        return (
          <FilesInput
            label={field.label}
            isRequired={field.required}
            isReadOnly={field.readOnly || field.displayOnly}
            isDisabled={field.disabled}
            value={attachments}
            onChange={onChange}
            uploadFn={uploadFn}
            acceptedFileTypes={field.acceptedFileTypes}
            maxFiles={field.maxFiles}
            maxFileSizeMb={field.maxFileSizeMb}
            uploadButtonLabel={field.placeholder}
            errorMessage={error}
            hideHelperText={hideHelperText}
            onPreview={onPreview}
          />
        )
      }}
    />
  )
}
